import { motion } from "framer-motion";
import IMG from "@/lib/images";

const QUOTES = [
  {
    quote:
      "Facetra collapsed our concept-to-render cycle from a week to an afternoon. Our brides are approving sets in the first sitting.",
    name: "Aanya Mehra",
    title: "Creative Director, Mehra Atelier",
    location: "Amravati",
    avatar: IMG.avatar1,
  },
  {
    quote:
      "It actually understands kundan and meenakari like our karigars do. The CAD references shaved 60% off our revision time.",
    name: "Vikram Soni",
    title: "Head of Manufacturing, Soni & Sons",
    location: "Surat",
    avatar: IMG.avatar2,
  },
  {
    quote:
      "Our bridal showroom finally has a tool that respects tradition while moving at modern speed. Investors noticed.",
    name: "Reema Iyer",
    title: "Founder, Indra Diamantaire",
    location: "Amravati",
    avatar: IMG.avatar1,
  },
];

export default function Testimonials() {
  return (
    <section className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <p className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-5">Words from the floor</p>
          <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] text-white">
            Trusted by jewellers <span className="italic gold-gradient-text">who know the craft</span>.
          </h2>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {QUOTES.map((q, i) => (
            <motion.figure
              key={q.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              data-testid={`testimonial-${i}`}
              className="glass-card rounded-2xl p-7 flex flex-col h-full"
            >
              <span className="font-display text-[#D4AF37] text-5xl leading-none">“</span>
              <blockquote className="mt-3 text-white/80 text-base md:text-[17px] leading-relaxed font-light italic font-display">
                {q.quote}
              </blockquote>
              <figcaption className="mt-auto pt-7 flex items-center gap-3 border-t border-white/5">
                <div
                  className="w-11 h-11 rounded-full bg-cover bg-center border border-[#D4AF37]/30"
                  style={{ backgroundImage: `url(${q.avatar})` }}
                />
                <div>
                  <div className="text-white text-sm font-medium">{q.name}</div>
                  <div className="text-white/45 text-xs">{q.title} · {q.location}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
